'use client';

import { ServerErrorLayout } from '@frameio/shared/layouts/ServerErrorLayout';

// Catch-all 500 page
// https://nextjs.org/docs/app/building-your-application/routing/error-handling#handling-errors-in-root-layouts
// To test this route you must throw an error in the root layout on a full build (local dev shows Next.js error dialog)
export default function GlobalErrorPage() {
  return (
    <html dir="ltr" lang="en">
      <head>
        <title>Frame.io</title>
      </head>
      <body>
        <ServerErrorLayout />
      </body>
    </html>
  );
}
